import {LOCAL_STORAGE_ORDER_DATA} from 'constants/analytics';
import {
    ALGOLIA_USER_TYPE,
    clearQueryStorage,
    getAllQueryObjects,
    sendAlgoliaAnalytics,
} from 'libs/algolia/sendAnalytics';
import {localStore} from 'libs/storage/storage';
import {GetQuoteType} from 'mobile/actions/checkout/checkout';

/**
 * Send the purchase analytics event to Algolia.
 */
export const sendAlgoliaPurchaseEvents = (
    customerId: string,
    platform: 'mobile' | 'desktop' = 'mobile',
): Promise<void> => {
    // eslint-disable-next-line max-statements, consistent-return
    return new Promise((resolve, reject) => {
        try {
            const orderData = localStore.get(LOCAL_STORAGE_ORDER_DATA);

            if (!orderData) {
                clearQueryStorage();
                return resolve();
            }

            const {quoteItems}: {quoteItems: GetQuoteType['quoteItems']} = JSON.parse(orderData);
            const cartProductIDs = new Set(quoteItems.map(item => String(item.product_id)));
            const algoliaQuery = getAllQueryObjects();

            algoliaQuery.forEach(({objectIDs, queryID}) => {
                const matchedIDs = objectIDs.filter(id => cartProductIDs.has(id));
                if (matchedIDs.length > 0) {
                    sendAlgoliaAnalytics(
                        [
                            {
                                eventName: `${platform === 'mobile' ? 'M' : 'D'} - Product Purchased`,
                                eventType: ALGOLIA_USER_TYPE.purchasedObjectIDsAfterSearch,
                                objectIDs: matchedIDs,
                                queryID,
                            },
                        ],
                        customerId,
                    );
                }
            });

            clearQueryStorage();

            resolve();
        } catch (error) {
            clearQueryStorage();

            reject(error);
        }
    });
};
